import { FC, PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  className?: string;
}

export const Pragraph: FC<Props> = ({ children, className }) => {
  return <p className={className ?? "indent-[1em]"}>{children}</p>;
};
